export default function Testimonials() {
  const testimonials = [
    {
      name: 'Ana Silva',
      location: 'Maputo',
      rating: 5,
      text: 'Adorei meu Crocs rosa! Os pins são super fofos e o conforto é incrível. Vale cada centavo dos 1.800 MZN!',
      image: 'https://public.readdy.ai/ai/img_res/0bd1b08d18e5688ee8444f770995e57b.jpg'
    },
    {
      name: 'Carlos Mendes',
      location: 'Beira',
      rating: 5,
      text: 'Comprei o preto para mim e o azul para meu filho. Qualidade excelente e atendimento rápido pelo WhatsApp!',
      image: 'https://readdy.ai/api/search-image?query=happy%20african%20man%20smiling%20portrait%20with%20colorful%20background%2C%20professional%20headshot%20photography%20with%20natural%20lighting%20and%20confident%20expression&width=400&height=400&seq=testimonial-002-moz&orientation=squarish'
    },
    {
      name: 'Mariana Costa',
      location: 'Nampula',
      rating: 5,
      text: 'Os pins decorativos são lindos! Meu Crocs amarelo é único e recebo elogios todos os dias. Super recomendo!',
      image: 'https://readdy.ai/api/search-image?query=happy%20young%20african%20woman%20smiling%20portrait%20with%20vibrant%20background%2C%20professional%20headshot%20photography%20with%20natural%20lighting%20and%20cheerful%20expression&width=400&height=400&seq=testimonial-003-moz&orientation=squarish'
    },
    {
      name: 'João Pereira',
      location: 'Matola',
      rating: 5,
      text: 'Melhor compra! O verde ficou perfeito e é super confortável. Entrega rápida e produto exatamente como na foto.',
      image: 'https://readdy.ai/api/search-image?query=happy%20african%20man%20smiling%20portrait%20with%20bright%20background%2C%20professional%20headshot%20photography%20with%20natural%20lighting%20and%20friendly%20expression&width=400&height=400&seq=testimonial-004-moz&orientation=squarish'
    },
    {
      name: 'Sofia Machado',
      location: 'Quelimane',
      rating: 5,
      text: 'Comprei o lilás e estou apaixonada! Os pins são muito criativos e o preço é justo. Mundo Crocs é top!',
      image: 'https://readdy.ai/api/search-image?query=happy%20young%20african%20woman%20smiling%20portrait%20with%20colorful%20background%2C%20professional%20headshot%20photography%20with%20natural%20lighting%20and%20warm%20expression&width=400&height=400&seq=testimonial-005-moz&orientation=squarish'
    },
    {
      name: 'Ricardo Lopes',
      location: 'Tete',
      rating: 5,
      text: 'Excelente! O laranja é vibrante e os pins dão um toque especial. Atendimento pelo WhatsApp foi perfeito!',
      image: 'https://readdy.ai/api/search-image?query=happy%20african%20man%20smiling%20portrait%20with%20vibrant%20background%2C%20professional%20headshot%20photography%20with%20natural%20lighting%20and%20positive%20expression&width=400&height=400&seq=testimonial-006-moz&orientation=squarish'
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-br from-pink-50 via-yellow-50 to-orange-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm text-orange-600 font-semibold mb-2">• Avaliações</p>
          <h2 className="text-6xl font-bold text-gray-900 mb-4">O Que Dizem Nossos Clientes</h2>
          <p className="text-xl text-gray-600">Centenas de clientes satisfeitos em todo Moçambique</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </div>

              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-yellow-400"></i>
                  </div>
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed">{testimonial.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <button
            onClick={() => window.open('https://wa.me/258869689262?text=Olá! Vi as avaliações e gostaria de fazer meu pedido.', '_blank')}
            className="inline-flex items-center gap-3 px-10 py-5 bg-green-500 text-white text-lg font-semibold rounded-full hover:bg-green-600 hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-whatsapp-line text-2xl"></i>
            </div>
            Faça Seu Pedido Agora
          </button>
        </div>
      </div>
    </section>
  );
}
